<button (click)="openInfoPanel(anchor); $event.stopPropagation();"  #anchor type="button">
    <bd-fa [name]="'info-circle'"></bd-fa>
</button>
